export default function messageListReducer(state = [], action) {
  if(action.message)
    return [action.message]
    
  return state
}